module.exports = __webpack_public_path__ + "static/media/20210403_222434_047_IMG_0095.4e6a6c3b.jpg";